import { decode } from 'html-entities'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import Icon from 'srcReact/components/icons/Icon'
import { messengerActions } from 'srcReact/MessengerPage'
import MemberImages from 'srcReact/components/common2/MemberImages'
import { getContentWithHighlightedText, isNativeIOS } from 'srcReact/helpers/utils'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { checkNested } from 'srcReact/helpers/validator'
import Badge from 'srcReact/components/common2/Badge'
import NoResultInSearch from '../NoResultInSearch'
import queryString from 'query-string'
import ReactTooltip from 'react-tooltip'
import MemberNames from 'srcReact/components/common2/MemberNames'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import FilterMenu from 'srcReact/components/common2/FilterMenu'
import { redirectToPage } from 'srcReact/helpers/history'
import IconButton from 'srcReact/components/common2/IconButton'
import EmptyConversation from '../EmptyConversation'
import NewConversation from '../NewConversation'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'

export default function ConversationList({
  isExpanded,
  isMobile,
  showBack = true,
  isDesktop,
  setIsNewConvOpen,
  showUserLightModal,
  fromQuickMessenger,
  setConversationId
}) {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    common: { isNative, isTablet },
    messenger: {
      openedConversation,
      conversation: { stats, list, loading, loaded },
      search,
      searchedMembers,
      filterItem
    }
  } = useSelector((state) => state)
  const [organizationId, setOrganizationId] = useState(getCurrentOrgId())
  const [searchText, setSearchText] = useState('')
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  useEffect(() => {
    if (!organizationId) {
      setOrganizationId(getCurrentOrgId())
    }
  }, [])

  useEffect(() => {
    if (organizationId > 0 && pagination.isPagination) {
      dispatch(messengerActions.getConversationsListPagination(organizationId, 1, filterItem, 0, pagination.nextOffset))
    }
  }, [pagination])
  // Search in conversations name, users name or messages content
  useEffect(() => {
    if (organizationId > 0 && searchText.length >= 2) {
      dispatch(messengerActions.getConversationsSearch(organizationId, filterItem, searchText))
    }
  }, [searchText])
  // Open conversation from URL link
  useEffect(() => {
    const queryParams = queryString.parse(window.location.search)
    const { key, userid, key1, key2, conversationId } = queryParams
    if (organizationId > 0 && userid) {
      dispatch(messengerActions.createConversation(organizationId, userid.toString()))
    } else if (conversationId > 0) {
      openConversation({}, conversationId)
    } else if (key) {
      dispatch(messengerActions.openConversationFromNotificationLink(key))
    } else if (key1 && key2) {
      dispatch(messengerActions.createConversationFromMailLink(key1, key2))
    }
  }, [organizationId])
  useEffect(() => {
    const searchInput = document.getElementById('searchInput')
    const closeSearchIcon = document.getElementById('closeSearchIcon')

    searchInput.addEventListener('focus', handleSearchInput)

    closeSearchIcon.addEventListener('click', handleCloseSearchIcon)

    return () => {
      searchInput.removeEventListener('focus', handleSearchInput)
      closeSearchIcon.removeEventListener('click', handleCloseSearchIcon)
    }
  }, [])

  const handleSearchInput = () => {
    const searchIconBG = document.getElementById('searchIconBG')
    searchInput.classList.add(styles.searchInputFocus)
    searchIconBG.classList.add(styles.searchIconBgFocus)
    closeSearchIcon.style.opacity = '1'
    closeSearchIcon.style.right = '0'
    closeSearchIcon.style.pointerEvents = 'auto'
  }

  const handleCloseSearchIcon = () => {
    const searchIconBG = document.getElementById('searchIconBG')
    searchInput.classList.remove(styles.searchInputFocus)
    searchInput.value = ''
    searchIconBG.classList.remove(styles.searchIconBgFocus)
    closeSearchIcon.style.right = '64px'
    closeSearchIcon.style.opacity = '0'
    closeSearchIcon.style.pointerEvents = 'none'
  }

  const lastConversationRef = useInfinitScroll(loading, stats.remaining, stats.nextOffset, setPagination, [loading])
  const startNewConversation = () => {
    dispatch(messengerActions.setSideBarScreenType('create'))
    if (isMobile) {
      setIsNewConvOpen(true)
    }
  }
  const openConversation = (conversation, conversationId, scrollToMessage) => {
    // dispatch(commonActions.getTagUsers('conversation', conversationId))
    dispatch(messengerActions.getConversationOpen(conversation, conversationId))
    // dispatch(messengerActions.showProcessSendContent(false, conversationId))
    const messageId = conversation?.content?.messages[0]?.id
    if (messageId && searchText.length >= 2) {
      dispatch(messengerActions.locateMessageInConversation(conversationId, messageId))
    }
    if (setConversationId) {
      setConversationId(conversationId)
    }
  }
  const handleSearch = (searchValue) => {
    setSearchText(searchValue)
  }
  const setFilterItem = (filter) => {
    dispatch(messengerActions.setFilterItem(filter))
  }
  const conversations = searchText.length >= 2 ? search.list : list

  return (
    <React.Fragment>
      {isDesktop ? (
        <div className={styles.isDesktop}>
          <div className={styles.actionWrapper}>
            <BackNavigation />
            <div
              type='button'
              className={styles.newChatButton}
              aria-label={t('messenger.startConversationButton')}
              data-tip={t('messenger.createNewConversation')}
              onClick={startNewConversation}>
              <div role='button' className={styles.startConversationButton} onClick={startNewConversation}>
                <Icon name='write' styleModifier={styles.startConversationIcon} />
              </div>
              <p>{t('messenger.startChat')}</p>
            </div>
            <ReactTooltip />
          </div>
          <div className={styles.actionWrapper}>
            <div className={styles.chats}>{t('messenger.chats')}</div>
            <div className={styles.searchInputContainer}>
              <SearchTextBox
                value={searchText}
                iconPosition='none'
                id='searchInput'
                minimumSearchChar={2}
                placeholder={t('messenger.searchPlaceholder')}
                handleSearch={handleSearch}
                cssClass={styles.searchContainer}
                inputCssClass={styles.searchInput}
              />
              <IconButton
                id='searchIconBG'
                iconName='search24'
                iconSize='large24'
                iconCSS={styles.searchIcon}
                className={`${styles.searchIconBg} ${fromQuickMessenger && styles.searchIconBgLight}`}
              />
              <IconButton
                id='closeSearchIcon'
                iconName='close24'
                iconSize='large24'
                iconCSS={styles.searchIcon}
                className={`${styles.closeSearchIconBg} ${fromQuickMessenger && styles.closeSearchIconBgLight}`}
                onClick={() => handleSearch('')}
              />
            </div>
            <FilterMenu
              filterItems={t('messenger.filterItems', { returnObjects: true })}
              filterItem={filterItem}
              setFilterItem={setFilterItem}
              filterClassName={styles.filterClassName}
              buttonClassName={styles.buttonClassName}
            />
          </div>
        </div>
      ) : (
        <div className={`${isNativeIOS() && styles.isNativeIOS}`}>
          <div className={styles.actionWrapper}>
            {showBack && <BackNavigation customHandleBack={() => redirectToPage('/0/myhome', isNative)} />}

            <div className={styles.searchInputContainer}>
              <SearchTextBox
                value={searchText}
                iconPosition='none'
                id='searchInput'
                minimumSearchChar={2}
                placeholder={t('messenger.searchPlaceholder')}
                handleSearch={handleSearch}
                cssClass={styles.searchContainer}
                inputCssClass={styles.searchInput}
                type='search'
              />
              <IconButton
                id='searchIconBG'
                iconName='search24'
                iconSize='large24'
                iconCSS={styles.searchIcon}
                className={`${styles.searchIconBg} ${fromQuickMessenger && styles.searchIconBgLight}`}
              />
              <IconButton
                id='closeSearchIcon'
                iconName='close24'
                iconSize='large24'
                iconCSS={styles.searchIcon}
                className={`${styles.closeSearchIconBg} ${fromQuickMessenger && styles.closeSearchIconBgLight}`}
                onClick={() => handleSearch('')}
              />
            </div>
          </div>
          <div className={styles.actionWrapper}>
            <FilterMenu
              filterItems={t('messenger.filterItems', { returnObjects: true })}
              filterItem={filterItem}
              setFilterItem={setFilterItem}
              filterClassName={styles.filterClassName}
              buttonClassName={styles.buttonClassName}
              activeClassName={styles.activeClassName}
            />
            <div
              type='button'
              aria-label={t('messenger.startConversationButton')}
              data-tip={t('messenger.createNewConversation')}
              className={styles.newChatButton}
              onClick={startNewConversation}>
              <IconButton
                iconName='write'
                iconSize='large24'
                iconCSS={styles.startConversationIcon}
                className={styles.startConversationButton}
              />
              <p>{t('messenger.newChat')}</p>
            </div>
            <ReactTooltip />
          </div>
        </div>
      )}

      {searchText.length >= 2 && search.loaded && search.list.length === 0 && (
        <React.Fragment>
          <NoResultInSearch customCss={styles.noresult} />
          <NewConversation
            deviceMode='common'
            showUserLightModal={showUserLightModal}
            isMobile={isMobile}
            setSearchText={setSearchText}
            searchText={searchText}
            setConversationId={setConversationId}
            fromQuickMessenger={fromQuickMessenger}
          />
        </React.Fragment>
      )}

      {conversations.length >= 1 && (
        <React.Fragment>
          <div className={styles.list}>
            {conversations.map((conversation, index) => {
              let searchedMessage = null

              let whoami = ''
              if (checkNested(conversation, 'content', 'messages') && conversation.content.messages.length > 0) {
                if (conversation.conversation.is_group_conversation == 1) {
                  if (openedConversation && conversation.conversation.id === openedConversation.conversation.id) {
                    if (conversation.content.messages[0].id_user == loggedInUser.id) {
                      whoami = `${t('messenger.you')}:&nbsp;`
                    } else if (conversation.content.messages[0].id_user != loggedInUser.id) {
                      const recentUser = openedConversation.active_users.find(
                        (u) => u.id == conversation.content.messages[0].id_user
                      )
                      whoami = recentUser ? `${recentUser.firstname}:&nbsp;` : ''
                    }
                  } else {
                    if (conversation.content.messages[0].id_user == loggedInUser.id) {
                      whoami = `${t('messenger.you')}:&nbsp;`
                    } else if (conversation.content.messages[0].id_user != loggedInUser.id) {
                      const recentUser = conversation.active_users.find(
                        (u) => u.id == conversation.content.messages[0].id_user
                      )
                      whoami = recentUser ? `${recentUser.firstname}:&nbsp;` : ''
                    }
                  }
                }
              }

              let hasUnreadMessage =
                conversation.conversation.userUnreadMessageCount > 0 &&
                conversation.conversation.isLeftByUser === 0 &&
                conversation.conversation.hasBeenRemoved === 0
              let lastUpdated = ''
              let lastMessage = ''
              let isMessageDeleted = false
              let showBadge = isMobile
                ? true
                : openedConversation &&
                  conversation.conversation.id !== openedConversation.conversation.id &&
                  searchText.length === 0

              if (checkNested(conversation, 'content', 'messages') && conversation.content.messages.length > 0) {
                const recentMessage = conversation.content.messages[0]

                if (recentMessage) {
                  lastUpdated = recentMessage.has_been_deleted
                    ? formatLastUpdateDate(recentMessage.deletedAt, '', t)
                    : formatLastUpdateDate(recentMessage.updatedAt, '', t)
                  if (recentMessage.has_been_deleted === 1) {
                    isMessageDeleted = true
                    lastMessage = t('messenger.deletedMessageText')
                  } else {
                    let lastMessages = recentMessage.message ? recentMessage.message.split('</div><div>') : []
                    if (lastMessages.length > 0) {
                      lastMessage = lastMessages[0]
                    } else if (recentMessage.files && recentMessage.files.length > 0) {
                      lastMessage = <Icon name='paperclip' />
                    } else {
                      lastMessage = ''
                    }
                  }
                }
              } else {
                lastMessage = t('messenger.startOfConversation')
              }

              //div with messageInGroup class added to handle display of bullet list in conversation list message
              const contentMessage =
                conversation.conversation.is_group_conversation == 1
                  ? `<div class='messageInGroup'>${whoami} ${lastMessage}</div>`
                  : lastMessage
              const convName = (
                <MemberNames
                  id={conversation.conversation.id}
                  members={conversation.active_users.filter((u) => !u.is_logged_user)}
                  conversationName={conversation.conversation.user_conversation_name}
                  isMobile={isMobile || isNative}
                  isTablet={isTablet}
                />
              )

              if (conversation.active_users.length > 1) {
                return (
                  <React.Fragment key={`${conversation.conversation.id}_${index}`}>
                    <button
                      type='button'
                      aria-label={convName}
                      ref={searchText.length >= 2 ? null : lastConversationRef}
                      className={`${styles.memberInList} ${!isExpanded && styles.memberInListCollapsed} ${
                        isDesktop &&
                        openedConversation &&
                        searchText.length === 0 &&
                        conversation.conversation.id === openedConversation.conversation.id &&
                        styles.memberInListSelected
                      } `}
                      onClick={() => openConversation(conversation, conversation.conversation.id, searchedMessage)}>
                      {/* {isDesktop && isExpanded && <span className={styles.lastUpdated}>{lastUpdated}</span>} */}
                      <div className={isExpanded ? styles.conversationDetails : styles.conversationDetailsCollapsed}>
                        <MemberImages
                          imgSizeSingle={fromQuickMessenger ? 'small' : 'medium64'}
                          imgSizeDouble={fromQuickMessenger ? 'tiny' : 'small48'}
                          imgSizeMore={fromQuickMessenger ? 'tiny' : 'small'}
                          imgSingleCss={`${styles.oneImageCSS} ${!isExpanded && styles.oneImageCSSCollapsed}`}
                          imgDoubleCss={styles.twoImageCSS}
                          imgMoreCss={styles.moreImageCSS}
                          displayCount={3}
                          conversationName={conversation.conversation.user_conversation_name}
                          members={conversation.active_users.filter((u) => !u.is_logged_user)}
                        />

                        {!isExpanded &&
                          conversation.conversation.userUnreadMessageCount > 0 &&
                          conversation.conversation.isLeftByUser === 0 &&
                          conversation.conversation.hasBeenRemoved === 0 && (
                            <Badge
                              customCss={styles.badgeCountCollapsed}
                              size='small'
                              color='red-crimson'
                              text={conversation.conversation.userUnreadMessageCount}
                            />
                          )}
                        <div
                          className={`${styles.conversationInfo} ${!isExpanded && styles.conversationInfoCollapsed} ${
                            isMobile && conversation.conversation.isMutedByUser === 1 && styles.conversationInfoWithMute
                          }`}>
                          {isMobile ? (
                            <div className={styles.convNameTimeContainer}>
                              <div className={`${styles.conversationName} ${hasUnreadMessage && styles.unreadMessage}`}>
                                {convName}
                              </div>
                              {lastUpdated && <span className={styles.lastUpdatedMobile}>{lastUpdated}</span>}
                            </div>
                          ) : (
                            <div className={styles.convNameTimeContainer}>
                              <div
                                className={
                                  isExpanded
                                    ? `${styles.conversationName} ${hasUnreadMessage && styles.unreadMessage}`
                                    : styles.conversationNameCollpased
                                }>
                                {convName}
                              </div>
                              {lastUpdated && <span className={styles.lastUpdatedMobile}>{lastUpdated}</span>}
                            </div>
                          )}

                          {isExpanded ? (
                            typeof lastMessage === 'object' ? (
                              <p className={`${styles.message} ${styles.italicStyle}`}>
                                <Icon name='paperclip24' styleModifier={styles.paperClipIcon} />
                                {t('global.media')}
                              </p>
                            ) : (
                              <div
                                className={`${styles.message} ${hasUnreadMessage && styles.unreadMessage} ${
                                  (lastMessage === t('messenger.startOfConversation') || isMessageDeleted) &&
                                  styles.italicStyle
                                } `}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    lastMessage === t('messenger.deletedMessageText')
                                      ? `${decode(contentMessage)}`
                                      : // : `<div>xasxas asx asx as x saxasx asx sa x as xas x as x as xas x as x sa xs  sss ss s  s sssss</div>`
                                        getContentWithHighlightedText(`${decode(contentMessage)}`, searchText, 4)
                                }}
                              />
                            )
                          ) : null}
                        </div>
                        {isExpanded && conversation.conversation.isMutedByUser === 1 && (
                          <div className={styles.muteIconContainer}>
                            <Icon styleModifier={styles.muteIcon} name='mute' size='large24' />
                          </div>
                        )}

                        {isExpanded &&
                          showBadge &&
                          conversation.conversation.userUnreadMessageCount >= 1 &&
                          conversation.conversation.isLeftByUser === 0 &&
                          conversation.conversation.hasBeenRemoved === 0 && (
                            <Badge
                              customCss={`${styles.badgeCount} ${fromQuickMessenger && styles.badgeCountMobile}`}
                              size='medium'
                              color='green'
                              text={conversation.conversation.userUnreadMessageCount}
                            />
                          )}
                      </div>
                    </button>
                    {(isMobile || fromQuickMessenger) && <div className={styles.border}></div>}
                  </React.Fragment>
                )
              }
            })}
            {loading && loaded && (
              <Spinner
                customCss={isExpanded ? styles.spinner : styles.spinnerCollapsed}
                isWhite={isMobile ? false : true}
              />
            )}
            {searchText.length >= 2 && search.loaded && (
              <NewConversation
                deviceMode='common'
                showUserLightModal={showUserLightModal}
                isMobile={isMobile}
                setSearchText={setSearchText}
                searchText={searchText}
                setConversationId={setConversationId}
                fromQuickMessenger={fromQuickMessenger}
              />
            )}
          </div>
        </React.Fragment>
      )}

      {!isDesktop && !loading && loaded && list.length === 0 && (
        <EmptyConversation handleClick={startNewConversation} />
      )}

      {((loading && !loaded && list.length === 0) || (search.loading && !search.loaded)) && (
        <Spinner customCss={isExpanded ? styles.spinner : styles.spinnerCollapsed} isWhite={isMobile ? false : true} />
      )}

      <div className={styles.finalLine}></div>

      {isMobile && (
        <div className={styles.startConversationBottomButton}>
          <IconButton
            iconName='write'
            iconSize='large24'
            iconCSS={styles.startConversationIcon}
            className={styles.startConversationButton}
            onClick={startNewConversation}
            aria-label={t('messenger.startConversationButton')}
            data-tip={t('messenger.createNewConversation')}
          />
        </div>
      )}
    </React.Fragment>
  )
}
